export default __webpack_public_path__ + "static/media/ssl_4.68c4ae47.PNG";